import { useState } from 'react';
import { toast } from 'sonner';
import { FlaskConical, Loader2 } from 'lucide-react';
import api from '../../lib/api';

export const TestEmailButton = ({ apiPath, subject, html, askEmail = false, className = '' }) => {
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!html || html.length < 30) return toast.error('El email está vacío — completá el contenido primero');
    const payload = { subject: subject || '(sin asunto)', body: html };
    if (askEmail) {
      const to = window.prompt('¿A qué email te mando el test?');
      if (!to || !to.includes('@')) return;
      payload.to_email = to.trim();
    }
    setSending(true);
    try {
      const r = await api.post(apiPath, payload);
      toast.success(`✉️ Test enviado a ${r.data.to} — revisá tu bandeja`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'No se pudo enviar el test');
    } finally {
      setSending(false);
    }
  };

  return (
    <button
      type="button"
      onClick={send}
      disabled={sending}
      className={`px-3 py-2 bg-sky-600/20 border border-sky-500/40 text-sky-300 hover:bg-sky-600/30 rounded-lg text-xs font-semibold flex items-center justify-center gap-1.5 disabled:opacity-50 ${className}`}
      data-testid="test-email-btn"
    >
      {sending ? <Loader2 size={13} className="animate-spin" /> : <FlaskConical size={13} />}
      Enviarme un test
    </button>
  );
};
